<div class="table-category">
    <div class="row">
        <div class="col-12 m-l-20">
            <div class="row">
                <!-- <div [ngClass]="['offset-2', 'col-' + (table.isScaleShown && table.scale.type === 'Combined'? 7 : 4)]">
                    <div class="rating-scale" *ngIf="table.isScaleShown">
   
                            <div class="scale-number" [ngSwitch]="table.scale.type">
                                <ng-template [ngSwitchCase]="'Text'">
                                    <div *ngFor=" let scorePoint of table.scale.values"> {{scorePoint.title}} </div>
                                </ng-template>
                                <ng-template [ngSwitchCase]="'Value'">
                                    <div *ngFor=" let scorePoint of table.scale.values"> {{scorePoint.value}} </div>
                                </ng-template>
                                <ng-template [ngSwitchCase]="'Combined'">
                                    <div *ngFor=" let scorePoint of table.scale.values">
                                        {{scorePoint.title}}({{scorePoint.value}}) </div>
                                </ng-template>
                            </div>
                            <div class="scale-line">
                                <div *ngFor="let values of table.scale.values"></div>
                            </div>
                      
                    </div>
                </div>
                <div class="col-1 assessments">
                    {{table.header.value}}
                </div>
                <div class="col-1 pl-0 pr-0 assessments" *ngFor="let period of table.header.previousPeriods">
                    {{period}}
                </div> -->

                <div class="scale-values-wrapper offset-2 col-4" style="padding-right:20px;line-height: 0.8">
                    <div class="scale-value" *ngFor="let scorePoint of table.body.rows[0].scorePoints">
                        <span class="scale-header">{{ scorePoint.value }}</span> 
                    </div>
    
                </div>
                <div class="col-1">Current Period</div>
            </div>
            <div class="row row-container" *ngFor="let row of table.body.rows">
                <div class="col-2 pr-0">
                        {{row.category}}
                </div>
                <div [ngClass]="['progress-parent', 'col-' + (table.isScaleShown && table.scale.type === 'Combined'? 7 : 4)]">
                        <div class="scale-container">
                            <div [ngClass]="['progress', row.type + '-opacity']">
                                <div [ngClass]="['progress-bar', row.type]" [ngStyle]="{'width': (row.average / row.maxValue) * 100 + '%'}">
                                </div>
                            </div>
                            <div class="scale-values-wrapper">
                                <div class="scale-value" *ngFor="let scorePoint of row.scorePoints">{{ scorePoint.votes }} </div>
                            </div>
                        </div>
  
                </div>
                <div class="col-1">
                    <div class="pt-1 font-weight-bold">
                        {{row.average}}
                    </div>
                </div>
                <ng-container *ngFor="let period of row.previousPeriodValues">
                    <div class="col-1 pl-0 period-years">
                        <div class="pt-1" *ngFor="let scorePoint of period">
                            {{scorePoint.value}}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
